export default __webpack_public_path__ + "static/media/ellipse_wallet_4.26e6926f.svg";